/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeEntryStatus
 */
export interface TimeEntryStatus {
    /**
     * 
     * @type {string}
     * @memberof TimeEntryStatus
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TimeEntryStatus
     */
    name: string;
}

/**
 * Check if a given object implements the TimeEntryStatus interface.
 */
export function instanceOfTimeEntryStatus(value: object): value is TimeEntryStatus {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function TimeEntryStatusFromJSON(json: any): TimeEntryStatus {
    return TimeEntryStatusFromJSONTyped(json, false);
}

export function TimeEntryStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeEntryStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function TimeEntryStatusToJSON(value?: TimeEntryStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

